import { render } from "./ManageMitigationModal.vue?vue&type=template&id=3c837414&scoped=true"
import script from "./ManageMitigationModal.js?vue&type=script&lang=js"
export * from "./ManageMitigationModal.js?vue&type=script&lang=js"

import "./ManageMitigationModal.vue?vue&type=style&index=0&id=3c837414&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c837414"]])

export default __exports__